import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { message } from "antd";

message.config({
  top: 50,
  duration: 2,
  maxCount: 1,
});

const root = ReactDOM.createRoot(document.getElementById("root"));

const ENV = process.env.REACT_APP_BASE_ENV;
const baseName = ENV === "future" ? "/future" : ENV === "dev" ? "/dev" : "";

console.log(process.env.REACT_APP_BASE_ENV);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={baseName}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
